import { createReducer, on } from '@ngrx/store';
import { IAuditLog, IAuditLogFilter } from './audit-log.interface';
import { AuditLogActions } from './audit-log.actions';
import { IResponseError } from '../../service/interface';

export const auditLogFeatureKey = 'auditLog';

export interface IState {
	auditLogs: IAuditLog[];
	loading: boolean;
	error?: IResponseError;
	filter: IAuditLogFilter;
}

export const initialState: IState = {
	auditLogs: [],
	loading: false,
	filter: {
		pagination: {
			count: 0,
			limit: 10,
			offset: 1,
		},
	},
};

export const reducer = createReducer(
	initialState,
	// ── API ──

	on(
		AuditLogActions.loadAuditLogs,
		(state): IState => ({
			...state,
			loading: true,
			error: undefined,
		}),
	),
	on(
		AuditLogActions.loadAuditLogsSuccess,
		(state, action): IState => ({
			...state,
			auditLogs: action.auditLogs,
			filter: {
				...state.filter,
				pagination: {
					...state.filter.pagination,
					count: action.pagination.count,
				},
			},
			loading: false,
			error: undefined,
		}),
	),
	on(
		AuditLogActions.loadAuditLogsError,
		(state, action): IState => ({
			...state,
			loading: false,
			error: action.error,
		}),
	),

	// ── UI ──

	on(
		AuditLogActions.setOffset,
		(state, action): IState => ({
			...state,
			loading: true,
			filter: {
				...state.filter,
				pagination: {
					...state.filter.pagination,
					offset: action.offset,
				},
			},
		}),
	),
	on(
		AuditLogActions.setLimit,
		(state, action): IState => ({
			...state,
			loading: true,
			error: undefined,
			filter: {
				...state.filter,
				pagination: {
					...state.filter.pagination,
					offset: 1,
					limit: action.limit,
				},
			},
		}),
	),
	on(
		AuditLogActions.setSortOrder,
		(state, action): IState => ({
			...state,
			filter: {
				...state.filter,
				sortBy: action.sortBy as IAuditLogFilter['sortBy'],
				orderBy: action.orderBy,
				pagination: {
					...state.filter.pagination,
					offset: 1,
				},
			},
		}),
	),
	on(
		AuditLogActions.clearSortOrder,
		(state): IState => ({
			...state,
			filter: {
				...state.filter,
				sortBy: undefined,
				orderBy: undefined,
				pagination: {
					...state.filter.pagination,
					offset: 1,
				},
			},
		}),
	),
	on(
		AuditLogActions.setFilter,
		(state, action): IState => ({
			...state,
			filter: {
				...state.filter,
				...action.data,
				pagination: {
					...state.filter.pagination,
					offset: 1,
				},
			},
		}),
	),
	on(
		AuditLogActions.resetFilter,
		(state): IState => ({
			...state,
			filter: initialState.filter,
		}),
	),
	on(
		AuditLogActions.clearAuditLogError,
		(state): IState => ({
			...state,
			error: undefined,
		}),
	),
);
